import React, { FC, useCallback, useEffect, useMemo, useRef } from 'react';
import { CarouselRef } from 'antd/lib/carousel';
import { useFilters } from '../../hooks/useFilters';
import { IPrmAnalysisResults } from '../../services/reports';
import ReportPRMGroupDistribution from '../ReportPRMGroupDistribution/ReportPRMGroupDistribution';
import ReportPRMGroupProportion from '../ReportPRMGroupProportion/ReportPRMGroupProportion';

interface IReportPRM {
  survey: string;
  prmResults: IPrmAnalysisResults;
  group: string;
}

const ReportPRM: FC<IReportPRM> = ({ survey, group, prmResults }) => {
  const { currentFilters, applyAndMergeFilters } = useFilters();

  const carouselRef = useRef<CarouselRef>(null);

  const prmFilters = useMemo(() => {
    const prm = currentFilters?.prm;

    if (prm) {
      // @ts-expect-error query-string types a value as string | string[]
      const prmFilters = JSON.parse(prm);

      return {
        slide: prmFilters?.slide || 0,
      };
    }
  }, [currentFilters?.prm]);

  const goToSlide = useCallback(
    (slideNr: number) => {
      applyAndMergeFilters('prm', 'slide', slideNr);
      carouselRef.current?.goTo(slideNr);
    },
    [carouselRef, applyAndMergeFilters]
  );

  useEffect(() => {
    const prmSlide = prmFilters?.slide || 0;

    if (prmSlide) {
      goToSlide(prmSlide);
    }
  }, []);

  return (
    <>
      <ReportPRMGroupDistribution {...{ survey, prmResults }} />
      <ReportPRMGroupProportion {...{ carouselRef, prmResults, goToSlide, group }} />
    </>
  );
};

export default ReportPRM;
